import React from 'react';

const Checkbox = ({ ...rest }) => {
  return <nsemble-checkbox {...rest} />;
};

export default Checkbox;
